module.exports = __webpack_public_path__ + "static/img/brees-2004-top-image-thumb.e176df2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-top-image-thumb.jpg
// module id = J4hw
// module chunks = 1